// 视图type
export default {
  text: 'InputModule',
  textarea: 'TextareaModule',
  radio: 'RadioModule',
  checkbox: 'CheckboxModule',
  'binary-choice': 'BinaryChoiceModule',
  'radio-star': 'StarModule',
  city: 'CityModule',
  vote: 'VoteModule',
  'matrix-checkbox': 'GroupModule',
  selectMoreModule: 'SelectMoreModule',
};
